import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vl-card',
  templateUrl: './vl-card.component.html',
  styleUrls: ['./vl-card.component.scss']
})
export class VlCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
